module.exports = __webpack_public_path__ + "img/rent.8d2cd253.svg";